module.exports = __webpack_public_path__ + "media/images/png/gps-2ee14f1dff9e269c1bbd1ffa549a3ff0.png";